import { apiClient } from '../../../client'

export function loopCSVExport() {
  return apiClient.post('v1/a/loops/csv')
}
